/* Library */
import React, { Component } from 'react';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import commonUtil from '../../../../../utils/commonUtil';

// Components
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import InputButton from '../../../../../components/ZUILib/InputButton';
import CheckBox from '../../../../../components/ZUILib/CheckBox';
import Link from '../../../../../components/ZUILib/Link';
import Image from '../../../../../components/ZUILib/Image/Image';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import { createTagsForInvalidFormControls } from '../../../../../utils/googleTagManagerUtils';


const channel = commonUtil.getChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();
const errorObject = require('../../../../../utils/errors/LP_GR_error.json');

export default class MulitiSelectItem extends Component {
  constructor(props) {
    super(props);
    this.getSelectedAddress = this.getSelectedAddress.bind(this);
    this.onDataUpdated = this.onDataUpdated.bind(this);
    this.address = this.props.currentAddress;
    this.redirectGRAddressPage = this.redirectGRAddressPage.bind(this);
    this.priority = '';
    this.disabled = false;
  }

  componentDidMount() {
    if (this.props.formData && this.props.formData.address && this.props.formData.address.addressId) {
      this.chk.setChecked(true);
      this.address = this.props.formData.address;
      this.selected = true;
      this.addressContainer.classList.add('visible');
      if (this.props.prioritiesOptions.length === 1) {
        this.forRadioButton.style.display = 'none';
      }
      this.priority = this.props.formData.priority;
    }
  }

  redirectGRAddressPage() {
    if (_.isFunction(this.props.onEditAddressClick)) this.props.onEditAddressClick();
    this.props.removeRouteLeaveHook();
    this.props.defineCreateEventData(this.props.currentIndex, { data: this.props.selectedAddresses });
    browserHistory.push(applicationRoutes.addDeliveryAddress + '?addressId=' + this.props.currentAddress.nickName);
  }
  updateData() {
    this.props.onSelection({ chkState: this.chk.isChecked(), address: this.address, priority: this.priority });
  }

  updateDataForRadio() {
    this.props.onClickOfRadioButton({ chkState: this.chk.isChecked(), address: this.address, priority: this.priority });
  }

  getSelectedAddressForRadioButton = (selectedAddress) => {
    this.selected = this.chk.isChecked();
    this.props.forRadioButton.forEach((item) => {
      if (this.selected && selectedAddress.addressId === item.addressId && this.props.prioritiesOptions.length === 1) {
        this.addressContainer.classList.add('visible');
        this.forRadioButton.style.display = 'none';
      } else if (this.selected && selectedAddress.addressId === item.addressId && this.props.prioritiesOptions.length > 1) {
        this.addressContainer.classList.add('visible');
        this.forRadioButton.style.display = 'block';
      }
    });
    this.address = selectedAddress;
    this.priority = {};
    if (this.props.addressToBeSelected === 1 || this.props.prioritiesOptions.length === 1) {
      this.priority = { option: this.props.celebName, value: this.props.celebName, disabled: false };
    }
    this.updateDataForRadio();
  }

  getSelectedAddress = (selectedAddress) => {
    this.selected = this.chk.isChecked();
    if (this.selected && this.props.prioritiesOptions.length === 1) {
      this.addressContainer.classList.add('visible');
      this.forRadioButton.style.display = 'none';
    } else if (this.selected) {
      this.addressContainer.classList.add('visible');
    } else {
      this.addressContainer.classList.remove('visible');
    }
    this.address = selectedAddress;
    this.priority = {};
    if (this.props.addressToBeSelected === 1 || this.props.prioritiesOptions.length === 1) {
      this.priority = { option: this.props.celebName, value: this.props.celebName, disabled: false };
    }
    this.updateData();
  }

  getSelectedPriority = (selectedPriority) => {
    this.priority = selectedPriority;
    this.props.onSelection({ chkState: true, address: this.address, priority: this.priority });
  }

  handleOnSumbitValidation = () => {
    let valid = true;
    if (this.chk.isChecked()) {
      if ((this.props.addressToBeSelected === 1 || this.props.prioritiesOptions.length === 1) || (this.props.selectedAddresses.length <= this.props.maxAddress)) {
        valid = true;
      } else {
        const titleValidValidationConfig = {
          functionRef: commonUtil.validateSelectedValue, funcData: [this.addressPriority.getSelectedIndex()], errorMessage: commonUtil.getError(errorObject.CreateEventStep3, 'CreateEventStep3.error.required'),
        };
        valid = commonUtil.validateSelecteTab(titleValidValidationConfig, this.addressPriority, null);

        if (!valid) {
          createTagsForInvalidFormControls({
            controls: [this.addressPriority],
            tagCompositor: c => ({
              event: 'alerta',
              phase: 'Crear mesa de ragalos',
              step: 'Direccion del evento',
              mensaje: _.get(c, 'errorControl.innerText', 'undefined error'),
              mensaje_servicio: _.get(c, 'errorControl.innerText', 'undefined error'),
              seccion: 'Mesa de Regalos',
              tipo: 'pop-up',
            }),
          });
        }
      }
      return valid;
    }
    if (valid) {
      document.getElementById('addressPriority').focus();
    }
    return valid;
  }

  onDataUpdated(data) {
    for (let i = 0; i < this.addressPriority.selectedOption.options.length; i++) {
      this.addressPriority.selectedOption.options[i].disabled = false;
    }
    data.map((item) => {
      if (item.address !== this.address) {
        for (let i = 0; i < this.addressPriority.selectedOption.options.length; i++) {
          if (typeof item.priority === 'object' && +this.addressPriority.selectedOption.options[i].id === item.priority.id) {
            this.addressPriority.selectedOption.options[i].disabled = true;
          }
        }
      }
      return undefined;
    });

    let exist = false;
    if (data.length <= this.props.maxAddress) {
      data.forEach((dataItem) => {
        if (dataItem.address.addressId === this.address.addressId) {
          exist = true;
        }
      });
      if (this.props.prioritiesOptions.length === 1) {
        this.disabled = exist;
      } else {
        this.disabled = exist;
      }

      if (!this.disabled && this.props.prioritiesOptions.length === 1) {
        this.addressContainer.classList.remove('visible');
        this.addressPriority.selectedOption.selectedIndex = 0;
      }
      if (!this.disabled && data.length >= this.props.maxAddress) {
        this.ctl.classList.add('disableBlock');
        this.ctl.style.display = 'block';
        this.addressPriority.selectedOption.selectedIndex = 0;
      } else {
         this.ctl.classList.remove('disableBlock');
         this.ctl.style.display = 'none';
      }
    } else {
      this.ctl.classList.remove('disableBlock');
      this.ctl.style.display = 'none';
    }
    const changeEl = document.getElementById("change");
    if (changeEl) {
      changeEl.innerHTML = data.length + " de " + this.props.prioritiesOptions.length;
    }
  }

  render() {
    const { lables } = this.props;
    const _imgsrc = [{
      media: '(max-width: 465px)',
      src: commonUtil.getAssetURL() + '/images/helpIcon.png',
    },
    ];
    const imageAttr = {
      id: 'img1',
      src: commonUtil.getAssetURL() + '/images/helpIcon.png',

    };
    const linkJSON = {
      text: 'Link Text',
      children: 'Please click here',
      areaLabel: 'abc',
      tabindex: -1,
      cssClass: 'helpIcon tooltip-container',
    };
    const buttonForEdit = {
      type: 'button',
      value: 'Editar dirección',
      autoFocus: false,
      onClickHandler: this.redirectGRAddressPage,
      style: (channel === 'wap') ? 'btnSecondarySpecial size-Full' : 'btnSecondarySpecial size-Large',
    };
    const currentUserNameDetail = (this.props.currentAddress && this.props.currentAddress.firstName ? this.props.currentAddress.firstName + ' ' : '') +
      (this.props.currentAddress && this.props.currentAddress.middleName ? this.props.currentAddress.middleName + ' ' : '') +
      (this.props.currentAddress && this.props.currentAddress.lastName ? this.props.currentAddress.lastName + ' ' : '') +
      (this.props.currentAddress && this.props.currentAddress.maternalName ? this.props.currentAddress.maternalName + ' ' : '');

    const currentAddress = (this.props.currentAddress && this.props.currentAddress.address1 ? this.props.currentAddress.address1 + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.exteriorNumber ? this.props.currentAddress.exteriorNumber + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.interiorNumber ? this.props.currentAddress.interiorNumber + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.building ? this.props.currentAddress.building + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.city ? this.props.currentAddress.city + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.neighbourhood ? this.props.currentAddress.neighbourhood + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.delegationMunicipality ? this.props.currentAddress.delegationMunicipality + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.postalCode ? this.props.currentAddress.postalCode + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.country ? this.props.currentAddress.country + ', ' : '') +
      (this.props.currentAddress && this.props.currentAddress.state ? this.props.currentAddress.state : '') + '.';

    return (
      <div key={'add' + this.props.currentAddress.ownerId} className="addressDetail">
        <div className="" style={{ height: '100%', display: 'none' }} ref={dv => this.ctl = dv} />
        <div className="addressSummary newAddressSummary">
          <div className="multipleAddress">
            <div className="inputBlock">
              {/* <div className="mobileCheckbox"></div> */}
              {/* {this.props.addressToBeSelected === 1 || this.props.forRadioButton.length === 1 || this.props.prioritiesOptions.length === 1 ?
                (<RadioButton radioCssClass={'oneAddress radio'} defaultChecked={false} id={this.props.currentAddress.addressId} value={this.props.currentAddress.addressId} name="radio" onChangeFunction={this.getSelectedAddressForRadioButton} {...this.props.currentAddress} ref={chk => this.chk = chk} />) : (<CheckBox className={'mobileCheckbox'} id={this.props.currentAddress.addressId} value={this.props.currentAddress.addressId} name={this.props.currentAddress.addressId} getSelectedValue={this.getSelectedAddress} {...this.props.currentAddress} ref={chk => this.chk = chk} />)} */}
                <CheckBox className={'mobileCheckbox'} id={this.props.currentAddress.addressId} value={this.props.currentAddress.addressId} name={this.props.currentAddress.addressId} getSelectedValue={this.getSelectedAddress} {...this.props.currentAddress} checked={this.props.isChecked} ref={chk => this.chk = chk} disabled={this.props?.forRadioButton?.length === 1} />
            </div>
          </div>
          <div>
            <h3 className='addressNickName'>{this.props.currentAddress.nickName}</h3>
          { this.props.isPredefined && <div className='predetermined'>Predeterminada</div> }
            <p className='newAddressText'> {currentAddress} </p>
            <p className="newAddressRegistered">Dirección registrada en Mesa de Regalos</p>
          </div>
        </div>
       {<div className="addressAsigned" ref={drpDiv => this.addressContainer = drpDiv}>
          <div>
            <span style={{ display: 'none' }} ref={forRadioButton => this.forRadioButton = forRadioButton}>
              <div className="headers formBlock">
                <p>Asignar dirección a festejado</p>
                <Link linkJSON={linkJSON}>
                  <Image imageAttr={imageAttr} _imgsrc={_imgsrc} />
                  <div id="helpPopup" className="tooltip-box dir-right">
                    <div className="arrow" />
                    <div className="popover-content">
                      <p>
                        {commonUtil.getLabel(lables.createEventStep3, 'creatEventStep3.helpIcon.message')}
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="formBlock" style={{display:"none"}}>
                <SelectionTab
                  classname="cSelect required"
                  id="addressPriority"
                  options={this.props.optionList}
                  optionCaption={'Selecciona Preferencia'}
                  optionText={'option'}
                  value={this.props.formData && this.props.formData.priority ? this.props.formData.priority.value : null}
                  optionValue={'value'}
                  handleSelectedOption={selectedPriority => this.getSelectedPriority(selectedPriority)}
                  disabled={this.props.prioritiesOptions.length <= 0}
                  ref={drp => this.addressPriority = drp}
                />
              </div>
            </span>
          </div>
          {/* <div>
            {this.address && this.address.isEventAssociated ?
              'Dirección registrada en Mesa de Regalos'
              :
              <InputButton buttonAttr={buttonForEdit} />
            }
          </div> */}
        </div> }
      </div >
    );
  }
}
